import React, {useEffect, useRef} from 'react';

const twitterWidgetScriptId = 'twitter-widget-script';

/**
 * Renders a blue twitter follow button.
 *
 * @param {string} twitterHandle - The twitter user to create the follow button for.
 * @param {boolean} showScreenName - Whether or not the button should say the screen name.
 */
export function TwitterFollowButton({twitterHandle, showScreenName = true}) {
    const twitterTagRef = useRef(null);
    const twitterUrl = `https://twitter.com/${twitterHandle}`;
    const linkText = `Follow @${twitterHandle}`;

    useEffect(() => {
        // Check if twitter script already on the page, if it is we
        // skip adding the script tag and instead initialize the widget.
        if (document.getElementById(twitterWidgetScriptId) && window.twttr) {
            window.twttr.widgets.load();
            return;
        }

        // Add the twitter widget script tag to the page.
        if (twitterTagRef.current) {
            const script = document.createElement("script");
            script.src = "https://platform.twitter.com/widgets.js";
            script.async = true;
            script.id = 'twitter-widget-script';
            twitterTagRef.current.insertAdjacentElement('beforebegin', script);
        }
    }, [twitterTagRef]);

    return (
        <a href={twitterUrl}
           className="twitter-follow-button"
           data-show-count="false"
           data-show-screen-name={showScreenName}
           ref={twitterTagRef}>
            {linkText}
        </a>
    );
}
